export default {
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  availableLocales: ["en", "el"],
};
